/**
 * Event IDs reserved for Concept One.
 *
 * Keep this range separate from the main application's EventKey values. The
 * numeric values are part of the persisted event-log format and must not be
 * changed after release.
 */
export enum C1_EventKey {
  ProjectOpened = 1000,
  ProjectSaved = 1001,
  FloorCreated = 1002,
  FloorSelected = 1003,
  RoomPlaced = 1004,
  RoomMoved = 1005,
  RoomDeleted = 1006,
  RoomResizedWithGrab = 1007,
  RoomDimensionChanged = 1008,
  FurniturePlaced = 1009,
  FurnitureMoved = 1010,
  FurnitureDeleted = 1011,
  ModeSelected = 1012,
  ViewSelected = 1013,
  PdfGenerated = 1014,
  // 1015 is reserved for historical ESTADA export events.
  EloItemToggled = 1016,
  EloItemMoved = 1017,
  EloItemDeleted = 1018,
  EloItemDetailsSelected = 1019,
  ProjectSelectionOpened = 1020,
  ProjectCreationSubmitted = 1021,
  ProjectCreated = 1022,
  // Placement events carry a "placementMethod" parameter describing how the
  // object was placed: "mousemoveClick" (tool armed, preview follows the
  // mouse, click places), "paletteDrag" (press on a palette item, drag onto
  // the plan, release) or "dragAndDrop" (native HTML drag and drop).
  WindowPlaced = 1023,
  DoorPlaced = 1024,
  StairsPlaced = 1025,
  EloItemPlaced = 1026,
  /** A consumer was connected with a button channel in the interaction concept. */
  ConnectionCreated = 1027,
  /** A search query was submitted in the right dockbar palette search. */
  PaletteSearchUsed = 1028,
  // PDF import funnel: Started → (PagePreviewed / ScaleChanged)* →
  // Confirmed or Cancelled → Completed or Failed.
  PdfImportStarted = 1029,
  PdfImportPagePreviewed = 1030,
  PdfImportScaleChanged = 1031,
  PdfImportConfirmed = 1032,
  PdfImportCancelled = 1033,
  PdfImportCompleted = 1034,
  PdfImportFailed = 1035,
  /** The imported floor plan background (PDF overlay) was shown or hidden. */
  PdfOverlayToggled = 1036,
  /** The PDF overlay opacity slider was released; opacity 0 hides the imported floor. */
  PdfOverlayOpacityChanged = 1037,
  // Shop (product selection) behaviour tracking.
  ShopOpened = 1038,
  ShopProductSelected = 1039,
  ShopProductFavoriteToggled = 1040,
  ShopProductRemoved = 1041,
  ShopCatalogOpened = 1042,
  ShopProductAdded = 1043,
  ShopProductDropReceived = 1044,
}

/** How a plan object was placed; see the placement event keys above. */
export type C1_PlacementMethod = "mousemoveClick" | "paletteDrag" | "dragAndDrop";
